module.exports = __webpack_public_path__ + "static/media/logo.d9197b63.jpeg";